import { render } from "./VideoTour.vue?vue&type=template&id=741b44b8&scoped=true"
import script from "./VideoTour.vue?vue&type=script&lang=js"
export * from "./VideoTour.vue?vue&type=script&lang=js"

import "./VideoTour.vue?vue&type=style&index=0&id=741b44b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741b44b8"]])

export default __exports__